import { render, staticRenderFns } from "./EditExchangeCurrency.vue?vue&type=template&id=b08b4cfe&"
import script from "./EditExchangeCurrency.vue?vue&type=script&lang=js&"
export * from "./EditExchangeCurrency.vue?vue&type=script&lang=js&"
import style0 from "./EditExchangeCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports